;(function ($, window, document, undefined) {
    var $win = $(window),
        $doc = $(document),
        $body = $('body');
    $doc.ready(function(){
      
      




      
            $(".gallery-slider").owlCarousel({
            loop: true,
            margin: 10,
            responsiveClass: true,
            nav: true,
            items: 3,
            dots: true,
            autoplay:true,
            autoplayTimeout:3000,
            autoplayHoverPause:true,
            responsive: {
                0: {
                    items: 1,
                    nav: false,
                      dots: true
                },
                768: {
                    items: 2,
                    nav: false,
                    dots: true
                },
                991: {
                    items: 3
                }
            }
        });
      
        });
      
})(jQuery, window, document);